import * as angular from "angular";
import {IController} from "angular";
import {AccountModel} from "../../../account/angular/models/account.model";

export class serviceAccountUsersTableRowCtrl implements IController {
  account: AccountModel;
  roles: any;
  rolesGroupIds: any;

  private isShowDeleteIcon: boolean;
  private isMobile: boolean;

  /* @ngInject */
  constructor(private $mdMedia) {
  }

  $onInit() {
    this.isMobile = !this.$mdMedia('gt-sm');
    this.isShowDeleteIcon = false;
  }

  swipeLeft() {
    this.isShowDeleteIcon = this.isMobile;
  }

  swipeRight() {
    this.isShowDeleteIcon = false;
  }

}

angular
  .module('bringoz.admin.admins')
  .component('serviceAccountUsersTableRow', {
    require: {
      serviceAccountUsersTableCtrl: '^serviceAccountUsersTable'
    },
    bindings: {
      account: '<',
      roles: '<',
      rolesGroupIds: '<'
    },
    template: require('./service-account-users-table-row.html').default,
    controller: serviceAccountUsersTableRowCtrl
  });
